import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
              平台优势
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              五大核心优势，打造极致的追剧体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {featureItems.map((item) => (
              <div
                key={item.title}
                className="group bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 text-center hover:border-primary-300 transition-colors duration-200 cursor-pointer"
              >
                <div className="w-12 h-12 mx-auto rounded-lg bg-primary-100 flex items-center justify-center text-primary-600 text-xl md:text-2xl mb-4 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={item.icon}></i>
                </div>
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}